export const mfNumberRange = {
    templateUrl: 'admin/views/mf-number-range.html',
    bindings: {
        descriptionText: '@',
        min: '<',
        max: '<',
        value: '=',
        valueFilter:'@'
    },
    //! @ngInject
    controller:  function($scope, $filter) {
        this.customFilter = (input) => {
            return  $scope.$ctrl.valueFilter ? $filter($scope.$ctrl.valueFilter)(input) : input;
        };
    }
};